const pageMain = document.querySelector('main');
const offerHandoff = pageMain?.querySelector('.ec-offer-handoff');
const governedSections = [...document.querySelectorAll('main > [data-ec-section]')];

governedSections
  .sort((a, b) => Number(a.dataset.ecSection.replace(/\D/g, '')) - Number(b.dataset.ecSection.replace(/\D/g, '')))
  .forEach((section) => pageMain?.insertBefore(section, offerHandoff || null));

const modal = document.querySelector('#ec-modal');
const modalKicker = modal.querySelector('[data-modal-kicker]');
const modalTitle = modal.querySelector('[data-modal-title]');
const modalBody = modal.querySelector('[data-modal-body]');
const modalImage = modal.querySelector('[data-modal-image]');
const modalSource = modal.querySelector('[data-modal-source]');
let modalTrigger = null;

const modalContent = {
  'soil-study': {
    kicker: 'Peer-reviewed evidence · 2024',
    title: 'Modern farming is drawing down a vital soil mineral.',
    body: `
      <p>Researchers compared the potassium removed through global cereal harvests with the potassium returned through fertiliser application.</p>
      <h3>What the study found</h3>
      <p>Across 61.4% of the cereal cropland studied, harvests removed more potassium than farming replaced. That means the usable mineral reserve in the soil was being progressively depleted.</p>
      <h3>Why it matters</h3>
      <p>Plants cannot manufacture minerals. They can only draw them from the ground, so depleted agricultural soil changes the mineral foundation available to the food grown in it.</p>`,
    source: 'Open the 2024 potassium-depletion study ↗',
    href: 'https://doi.org/10.1016/j.scitotenv.2023.167875'
  },
  'mineral-spectrum': {
    kicker: 'Natural mineral spectrum',
    title: 'A naturally occurring spectrum of trace minerals.',
    body: `
      <p>Shilajit is a natural organic-mineral matrix. Recent composition research reports essential minerals including calcium, magnesium and potassium, plus trace elements such as zinc, iron and selenium.</p>
      <h3>Minerals reported in Shilajit</h3>
      <ul>
        <li><strong>Magnesium</strong> — supports normal energy production, muscle function and nerve function.</li>
        <li><strong>Iron</strong> — supports oxygen transport and normal energy metabolism.</li>
        <li><strong>Zinc</strong> — supports normal immune function and protein synthesis.</li>
        <li><strong>Calcium</strong> — supports muscle function and the maintenance of normal bones.</li>
        <li><strong>Potassium</strong> — supports normal nerve signalling, muscle function and fluid balance.</li>
        <li><strong>Selenium</strong> — supports normal antioxidant defence and thyroid function.</li>
      </ul>
      <h3>What the composition study found</h3>
      <p>Using modern elemental-analysis methods, researchers confirmed that Shilajit contains a diverse natural mineral profile. The exact spectrum and amounts vary with origin, so the examples above explain the composition—not a fixed dose claim for every mineral.</p>`,
    source: 'Read the 2025 Shilajit composition study ↗',
    href: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12703986/'
  },
  'fulvic-compounds': {
    kicker: 'Fulvic acid',
    title: 'Supports mineral interaction and natural antioxidant activity.',
    body: `
      <p>Fulvic acid is a small, water-soluble natural fraction of Shilajit. Its oxygen-rich structure allows it to bind and interact with minerals, while laboratory research also identifies strong antioxidant activity.</p>
      <h3>Benefits under study</h3>
      <ul>
        <li><strong>Mineral interaction</strong> — fulvic acid can chelate and carry mineral ions.</li>
        <li><strong>Antioxidant support</strong> — research describes free-radical-scavenging activity.</li>
        <li><strong>Availability</strong> — its low molecular weight and water solubility help explain why it is considered a key active fraction of Shilajit.</li>
      </ul>
      <h3>What the review found</h3>
      <p>The review identifies fulvic acid as one of Shilajit’s principal biologically active components and highlights its antioxidant properties and carrier behaviour.</p>`,
    source: 'Read the fulvic-acid review ↗',
    href: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC3296184/'
  },
  'humic-compounds': {
    kicker: 'Humic acid',
    title: 'Supports antioxidant defence through a complex natural matrix.',
    body: `
      <p>Humic acid is the larger, more complex natural organic fraction measured in Shilajit. Its phenolic, quinone and carboxylic functional regions are studied for their ability to interact with reactive molecules and metal ions.</p>
      <h3>Benefits under study</h3>
      <ul>
        <li><strong>Antioxidant defence</strong> — humic acid has shown free-radical-scavenging activity in laboratory research.</li>
        <li><strong>Redox balance</strong> — its functional groups can donate or accept electrons during oxidative reactions.</li>
        <li><strong>Binding activity</strong> — its complex structure can bind selected ions and reactive compounds.</li>
      </ul>
      <h3>What the research found</h3>
      <p>A recent biomedical review found that humic acid’s antioxidant behaviour is linked to its phenolic and non-phenolic structural components. This is an active research area rather than a single fixed clinical outcome.</p>`,
    source: 'Read the 2025 humic-substances review ↗',
    href: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12466450/'
  },
  'shilajit-fatigue-study': {
    kicker: 'Human research · 8 weeks',
    title: 'Purified Shilajit was tested after a fatiguing strength protocol.',
    body: `
      <p>Researchers randomly assigned 63 recreationally active men to 250 mg of purified Shilajit daily, 500 mg daily, or placebo for eight weeks. The trial was double-blind and placebo-controlled.</p>
      <h3>What researchers measured</h3>
      <p>The team measured maximal voluntary isometric strength before and after a fatiguing leg-extension protocol, alongside peak torque and serum hydroxyproline.</p>
      <h3>What the study found</h3>
      <p>In the study’s upper-strength subgroup, the 500 mg group had a smaller fatigue-induced decline in maximal strength than the 250 mg and placebo groups. The adjusted decline was 8.9% for 500 mg, 17.0% for 250 mg and 16.0% for placebo.</p>
      <h3>Why it matters</h3>
      <p>The study provides human evidence that 500 mg of purified Shilajit daily can support retention of muscular strength following fatigue under the tested conditions. It measured a specific exercise outcome—not instant stimulation or a guaranteed individual result.</p>`,
    source: 'Read the full peer-reviewed study ↗',
    href: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC6364418/'
  },
  'capsules-report': {
    kicker: 'Current Capsules product evidence',
    title: 'Inspect the current Shilajit Capsules report and label.',
    body: `
      <p>The product-linked document identifies the Essencraft Shilajit product, report scope and laboratory results. The approved Capsule label separately confirms the 120-count bottle and labelled serving of two capsules daily.</p>
      <h3>What this section lets you verify</h3>
      <ul>
        <li>Product identity and report scope</li>
        <li>120 capsules in each bottle</li>
        <li>Two-capsule labelled daily serving</li>
        <li>60-day supply at labelled use</li>
      </ul>
      <h3>Why the original document matters</h3>
      <p>Open the analytical report itself rather than relying on a generic testing badge. The Shopify build must bind this section to the current Capsules-specific document.</p>`,
    image: window.ECCapsulesV3Assets?.reportPreview || '',
    source: 'Open the current Shilajit analytical report ↗',
    href: window.ECCapsulesV3Assets?.reportPdf || '#'
  }
};

function openModal(key, trigger) {
  const content = modalContent[key];
  if (!content) return;

  modalTrigger = trigger;
  modalKicker.textContent = content.kicker;
  modalTitle.textContent = content.title;
  modalBody.innerHTML = content.body;
  modalSource.textContent = content.source;
  modalSource.href = content.href;

  if (content.image) {
    modalImage.src = content.image;
    modalImage.alt = `${content.title} document preview`;
    modalImage.hidden = false;
  } else {
    modalImage.hidden = true;
    modalImage.removeAttribute('src');
    modalImage.alt = '';
  }

  modal.showModal();
  modal.querySelector('.ec-modal__close').focus();
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  if (!modal.open) return;
  modal.close();
  document.body.style.overflow = '';
  modalTrigger?.focus();
}

document.querySelectorAll('[data-modal-key]').forEach((button) => {
  button.addEventListener('click', () => openModal(button.dataset.modalKey, button));
});

const galleryStageImage = document.querySelector('.ec-cap-gallery__stage img');
document.querySelectorAll('.ec-cap-gallery__thumbs button').forEach((button) => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.ec-cap-gallery__thumbs button').forEach((item) => item.classList.toggle('is-active', item === button));
    const image = button.querySelector('img');
    if (!galleryStageImage || !image) return;
    galleryStageImage.src = image.src;
    galleryStageImage.alt = image.alt;
  });
});

document.querySelectorAll('.ec-cap-cadences, .ec-protected-offer__plans').forEach((group) => {
  group.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => group.querySelectorAll('button').forEach((item) => item.classList.toggle('is-active', item === button)));
  });
});

const proofQuote = document.querySelector('[data-proof-current]');
const proofLabel = document.querySelector('[data-proof-label]');
const proofLink = document.querySelector('[data-proof-link]');
const proofOptions = [...document.querySelectorAll('[data-proof-option]')];
const proofSelector = document.querySelector('.ec-proof-selector');

proofOptions.forEach((option) => {
  option.addEventListener('click', () => {
    proofOptions.forEach((item) => {
      const selected = item === option;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
    });

    proofQuote.textContent = option.dataset.proofQuote;
    proofQuote.classList.remove('is-switching');
    requestAnimationFrame(() => proofQuote.classList.add('is-switching'));
    proofLabel.textContent = option.dataset.proofLabel;
    proofLink.href = option.dataset.proofSource;
    proofSelector?.style.setProperty('--proof-index', option.dataset.proofIndex);
  });
});

const routine = document.querySelector('.ec-routine');
const routineSteps = [...document.querySelectorAll('[data-routine-step]')];
const routineTip = document.querySelector('[data-routine-current-tip]');
let routineSequenceTimers = [];

function activateRoutineStep(step) {
  const index = Number(step.dataset.routineIndex || 0);
  routineSteps.forEach((item) => {
    const selected = item === step;
    item.classList.toggle('is-active', selected);
    item.setAttribute('aria-selected', String(selected));
  });

  routine?.style.setProperty('--routine-progress', `${index * 50}%`);
  if (!routineTip) return;
  routineTip.textContent = step.dataset.routineTip;
  routineTip.classList.remove('is-switching');
  requestAnimationFrame(() => routineTip.classList.add('is-switching'));
}

routineSteps.forEach((step) => {
  step.addEventListener('click', () => {
    routineSequenceTimers.forEach(clearTimeout);
    routineSequenceTimers = [];
    routine?.removeAttribute('data-routine-playing');
    activateRoutineStep(step);
  });
});

const sensoryChoices = [...document.querySelectorAll('[data-sensory-choice]')];
const sensoryLabel = document.querySelector('[data-sensory-current-label]');
const sensoryTip = document.querySelector('[data-sensory-current]');

sensoryChoices.forEach((choice) => {
  choice.addEventListener('click', () => {
    sensoryChoices.forEach((item) => {
      const selected = item === choice;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
    });

    if (sensoryLabel) sensoryLabel.textContent = choice.dataset.sensoryLabel;
    if (!sensoryTip) return;
    sensoryTip.textContent = choice.dataset.sensoryTip;
    sensoryTip.classList.remove('is-switching');
    requestAnimationFrame(() => sensoryTip.classList.add('is-switching'));
  });
});

modal.querySelectorAll('[data-modal-close]').forEach((button) => {
  button.addEventListener('click', closeModal);
});

modal.addEventListener('cancel', (event) => {
  event.preventDefault();
  closeModal();
});

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('is-visible');
    revealObserver.unobserve(entry.target);
  });
}, { threshold: 0.16, rootMargin: '0px 0px -7% 0px' });

document.querySelectorAll('[data-ec-section], [data-reveal]').forEach((element) => revealObserver.observe(element));

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const routineObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting || prefersReducedMotion || !routine || routine.dataset.routinePlayed === 'true') return;
    routine.dataset.routinePlayed = 'true';
    routine.dataset.routinePlaying = 'true';
    routineSequenceTimers = routineSteps.map((step, index) => window.setTimeout(() => {
      activateRoutineStep(step);
      if (index === routineSteps.length - 1) routine.removeAttribute('data-routine-playing');
    }, index * 900));
    routineObserver.unobserve(routine);
  });
}, { threshold: .48 });

if (routine) routineObserver.observe(routine);

const outcomeSection = document.querySelector('#ec-sec-04');
const outcomePanels = [...document.querySelectorAll('[data-outcome-panel]')];
const outcomeProgress = [...document.querySelectorAll('.ec-outcome-progress span')];
let activeOutcome = 0;
let outcomeFrame = 0;

function setOutcome(index) {
  if (index === activeOutcome) return;
  activeOutcome = index;
  outcomePanels.forEach((panel, panelIndex) => {
    const isActive = panelIndex === index;
    panel.classList.toggle('is-active', isActive);
    panel.setAttribute('aria-hidden', String(!isActive));
  });
  outcomeProgress.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
}

function updateOutcomeFromScroll() {
  outcomeFrame = 0;
  if (!outcomeSection) return;
  const rect = outcomeSection.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  if (rect.bottom <= 0) {
    setOutcome(2);
    return;
  }
  if (rect.top >= viewportHeight) {
    setOutcome(0);
    return;
  }

  const pinnedScene = outcomeSection.querySelector('.ec-sec-04__inner');
  const pinnedHeight = pinnedScene?.getBoundingClientRect().height || viewportHeight;
  const scrollableDistance = Math.max(rect.height - pinnedHeight, 1);
  const progress = Math.min(1, Math.max(0, -rect.top / scrollableDistance));

  if (progress < 1 / 3) setOutcome(0);
  else if (progress < 2 / 3) setOutcome(1);
  else setOutcome(2);
}

function requestOutcomeUpdate() {
  if (outcomeFrame) return;
  outcomeFrame = requestAnimationFrame(updateOutcomeFromScroll);
}

window.addEventListener('scroll', requestOutcomeUpdate, { passive: true });
window.addEventListener('resize', requestOutcomeUpdate);
requestOutcomeUpdate();

function animateCount(element) {
  if (element.dataset.counted === 'true') return;
  element.dataset.counted = 'true';

  const target = Number(element.dataset.count);
  const decimals = Number(element.dataset.decimals || 0);
  if (prefersReducedMotion) {
    element.textContent = target.toFixed(decimals);
    return;
  }

  const start = performance.now();
  const duration = 1050;

  function frame(now) {
    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    element.textContent = (target * eased).toFixed(decimals);
    if (progress < 1) requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}

const countObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    animateCount(entry.target);
    countObserver.unobserve(entry.target);
  });
}, { threshold: .65 });

document.querySelectorAll('[data-count]').forEach((element) => countObserver.observe(element));

document.querySelectorAll('.ec-facts__details details').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (!details.open) return;
    document.querySelectorAll('.ec-facts__details details[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  });
});
